import React, { useRef } from "react";
import "../styles/components/UserProfile.css";
import ScrollToTopButton from "./scroll-to-top/ScrollToTopButton";
import useScrollToTopButton from "./scroll-to-top/useScrollToTopButton";
import UserProfileActionPanels from "./user-profile/UserProfileActionPanels";
import UserProfileContentSections from "./user-profile/UserProfileContentSections";
import UserProfileHeaderSection from "./user-profile/UserProfileHeaderSection";
import useUserProfileState from "./user-profile/useUserProfileState";

export default function UserProfile(props) {
  const overlayRef = useRef(null);
  const profile = useUserProfileState(props);
  const { isVisible, scrollToTop } = useScrollToTopButton({
    targetRef: overlayRef,
  });
  const hasDesktopShellNavbar = Boolean(props.desktopShellNavbar);
  const hasDesktopShellSidebar = Boolean(props.desktopShellSidebar);
  const hasDesktopShellRightPanel = Boolean(props.desktopShellRightPanel);
  const hasDesktopShellLayout =
    hasDesktopShellSidebar || hasDesktopShellRightPanel;

  if (!props.selectedUser) return null;
  if (props.user && props.selectedUser === props.user.username) return null;

  return (
    <div className="userprofile-container" ref={overlayRef}>
      <ScrollToTopButton isVisible={isVisible} onClick={scrollToTop} />
      {hasDesktopShellNavbar ? props.desktopShellNavbar : null}
      <div
        className={
          hasDesktopShellLayout
            ? "userprofile-container__desktop-layout"
            : "userprofile-container__content"
        }
      >
        {hasDesktopShellSidebar ? (
          <aside className="userprofile-container__desktop-sidebar">
            {props.desktopShellSidebar}
          </aside>
        ) : null}

        <div className="userprofile-container__main">
          <UserProfileHeaderSection
            profile={profile}
            onOpenSharedSidebar={props.onOpenSharedSidebar}
          />
          <UserProfileContentSections profile={profile} />
          <UserProfileActionPanels profile={profile} />
        </div>

        {hasDesktopShellRightPanel ? (
          <aside className="userprofile-container__desktop-rightpanel">
            {props.desktopShellRightPanel}
          </aside>
        ) : null}
      </div>
    </div>
  );
}
